import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=5fd56e10&scoped=true&"
import script from "./Schedule.vue?vue&type=script&lang=ts&"
export * from "./Schedule.vue?vue&type=script&lang=ts&"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=5fd56e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd56e10",
  null
  
)

export default component.exports